export enum communityReportState {
  CREATED = 'Created',
  REJECTED = 'Rejected',
  DELETED = 'Deleted',
  CENSORED = 'Censored'
}
